/**
 * GeChiUI dependencies
 */
import { createContext } from '@gechiui/element';

const RadioContext = createContext( {
	state: null,
	setState: () => {},
} );

export default RadioContext;
